import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import "@/assets/css/reset.css"
import "@/assets/css/animate.min.css"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {isIntersecting} from '@/util/directive.js'
axios.defaults.baseURL = 'http://47.97.84.75:8080'
Vue.use(ElementUI)

Vue.prototype.axios = axios;
Vue.use(axios);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
